export const STATUS_COLORS = {
  color_cc_red: "#950101",
  color_pi_red: "#EC407A",
  color_cc_green: "#005B41",
  color_pi_green: "#66BB6A",
  color_warning: "#FFA000",
  color_primary: "#1976D2",
  color_green: "#4CAF50",
}

export const getChapterStatus = (chapterProgress) => {
  if (!chapterProgress) return STATUS_COLORS.color_primary

  const currentTime = Date.now()
  const {
    scheduledStartTime = 0,
    scheduledEndTime = 0,
    completed = {},
    started = {},
  } = chapterProgress

  const { status: isCompleted, timestamp: completionTime = 0 } = completed
  const { status: isStarted } = started

  const isLate = currentTime > scheduledEndTime
  const isOnTime = currentTime >= scheduledStartTime && currentTime <= scheduledEndTime
  const isBeforeStart = currentTime < scheduledStartTime

  if (isLate && !isStarted && !isCompleted) return STATUS_COLORS.color_cc_red
  if (isLate && isCompleted && completionTime > scheduledEndTime) return STATUS_COLORS.color_pi_red
  if (isLate && isCompleted && completionTime <= scheduledEndTime) return STATUS_COLORS.color_cc_green
  if (isOnTime && isStarted) return STATUS_COLORS.color_pi_green
  if (isOnTime && !isStarted) return STATUS_COLORS.color_warning
  if (isBeforeStart && !isStarted) return STATUS_COLORS.color_primary
  if (isBeforeStart && isStarted) return STATUS_COLORS.color_green

  return STATUS_COLORS.color_primary
}

